<template>
  <div class="content content-full gamification-page">
    <div class="page-inner">
      <div class="row" v-if="currentArtist._id">
        <div class="col-md-4">
          <div class="card card-profile bg-dark text-white">
            <div class="card-header header-avatar" style="background-image: url('/static/img/gamification/banner-bg.jpg')">
              <div class="profile-picture">
                <div class="avatar avatar-xl">
                  <img onerror="this.src = '/static/img/img-placeholder-dark.jpg'" :src="currentArtist.cover_image_small || currentArtist.cover_image" alt="..." class="avatar-img rounded-circle">
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="user-profile text-center">
                <div class="pos-relative">
                  <div class="name">
                    <span>
                      {{ (currentArtist.name || '') | truncate(27) }}
                    </span>
                    <div class="dropdown dropdown-artists d-inline ml-1">
                      <button class="btn btn-default btn-xs dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a v-for="(artist, index) in artists" class="dropdown-item" href="javascript:void(0)" v-bind:key="`artistSelect_${index}`" @click="changeArtist(artist)">
                          {{ artist.name  }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="job">{{ currentArtist.ranking && currentArtist.ranking.length ? $t(currentArtist.ranking[0].rank.toLowerCase()) : 'Unranked' }}</div>
                </div>
                <div class="mt-3">
                  <div class="progress rank-progress">
                    <div class="progress-bar bg-success" role="progressbar" :style="`width: ${(artistScore / artistNextScore * 100) || 1}%`" :aria-valuenow="(artistScore / artistNextScore * 100)" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer mt-2">
              <div class="row user-stats text-center">
                <div class="col">
                  <div class="number">{{ numberWithCommas(artistScore) }} / {{ numberWithCommas(artistNextScore) }}</div>
                  <div class="title">{{ $t('next_rank') }}</div>
                </div>
                <div class="col">
                  <div class="number">
                    {{ achievments }}
                  </div>
                  <div class="title">{{ $t('achievments') }}</div>
                </div>
                <div class="col">
                  <div class="number">{{ medals }}</div>
                  <div class="title">{{ $t('medals') }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="marquee-container mb-4">
            <div class="marquee-title bg-dark">
              TOP 10
            </div>
            <marquee class="card-round bg-dark p-2 text-white">
              <span v-for="(item, index) in top10" v-bind:key="`top_${item._id}`" class="mr-4">
                <span class="mr-1"># {{ index + 1 }}:</span> <a class="blue-text" target="_blank" :href="`https://indiefy.me/${item.key}`"><img v-if="item.user.country" class="mr-1 mt--1" width="16" onerror="this.src = '/static/img/img-placeholder-dark.jpg'" :src="`/static/img/countries/${item.user.country || 'default'}.png`"> {{ item.name }}</a>
              </span>
            </marquee>
          </div>

          <div class="card card-round bg-dark rankings" v-show="artistsShortList">
            <div class="card-body">
              <div class="card-title fw-mediumbold clearfix text-white">
                <span class="pull-left">
                  {{ $t('nearby_rankings') }}
                </span>
                <router-link to="/challenges/rankings" class="btn btn-sm btn-light pull-right">
                  <i class="fa fa-crown text-warning"></i>
                </router-link>
              </div>
              <div class="py-3">
                <select class="form-control genres-select mb-2" v-model="countryFilter" @change="changeCountry()">
                    <option value="">{{ $t('all_countries') }}</option>
                    <option v-for="(_country, index) in countries" :value="_country" v-bind:key="`country_${index}`">{{ _country }}</option>
                  </select>
                <select class="form-control genres-select" v-model="genre" @change="changeGenre()">
                  <option value="">{{ $t('all_genres') }}</option>
                  <option v-for="(genre, index) in genres" :value="genre" v-bind:key="`genre_${index}`">{{ genre }}</option>
                </select>
              </div>
              <div v-if="loadingNearbyRankings" class="text-center p-3 text-white">
                <i class="fa fa-spinner fa-spin"></i>
              </div>
              <div class="card-list" v-if="!loadingNearbyRankings">
                <div class="item-list" v-for="item in artistsShortList" v-bind:key="item._id">
                  <div class="avatar">
                    <a :href="`https://indiefy.me/${item.key}`" target="_blank">
                      <img :src="item.cover_image_small || item.cover_image || '/static/img/img-placeholder-dark.jpg'" alt="..." class="avatar-img rounded-circle" onerror="this.src = '/static/img/img-placeholder-dark.jpg'">
                    </a>
                  </div>
                  <div class="info-user ml-3">
                    <a :href="`https://indiefy.me/${item.key}`" target="_blank" class="username">{{ item.name }}</a>
                    <div class="status">{{ item.ranking ? $t(item.ranking.rank.toLowerCase()) : 'Unranked' }}</div>
                  </div>
                  <button class="badge badge-default btn-round btn-xs">
                    {{ item.ranking ? numberWithCommas(item.ranking.score) : 0 }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="card">
            <div class="card-body">
              Medals Here
            </div>
          </div> -->
        </div>
        <div class="col-md-8">
          <div class="nav-scroller mt-2">
            <div class="nav nav-tabs nav-line nav-color-secondary d-flex align-items-center justify-contents-center w-100" >
              <router-link :to="{ path: '/challenges', query: { page: 1, tab: 'all', country: countryFilter, genre: genre } }" class="nav-link" :class="{ active: tab === 'all' }">
                {{ $t('all') }}
                <span
                  class="count ml-1"
                  v-if="allChallenges"
                >({{ allChallenges }})</span>
              </router-link>
              <router-link :to="{ path: '/challenges', query: { page: 1, tab: 'streams', country: countryFilter, genre: genre } }" class="nav-link" :class="{ active: tab === 'stremas' }">
                {{ $t('streams') }}
                <span class="count ml-1" v-if="streams">({{ streams }})</span>
              </router-link>
              <router-link :to="{ path: '/challenges', query: { page: 1, tab: 'country', country: countryFilter, genre: genre } }" class="nav-link" :class="{ active: tab === 'country' }">
                {{ $t('countries') }}
                <span class="count ml-1" v-if="country">({{ country }})</span>
              </router-link>
              <router-link :to="{ path: '/challenges', query: { page: 1, tab: 'releases', country: countryFilter, genre: genre } }" class="nav-link" :class="{ active: tab === 'releases' }">
                {{ $t('releases') }}
                <span class="count ml-1" v-if="releases">({{ releases }})</span>
              </router-link>
              <router-link :to="{ path: '/challenges', query: { page: 1, tab: 'dsps', country: countryFilter, genre: genre } }" class="nav-link" :class="{ active: tab === 'dsps' }">
                DSPs
                <span class="count ml-1" v-if="dsps">({{ dsps }})</span>
              </router-link>
              <router-link :to="{ path: '/challenges', query: { page: 1, tab: 'pros', country: countryFilter, genre: genre } }" class="nav-link" :class="{ active: tab === 'pros' }">
                PRO
                <span class="count ml-1" v-if="dsps">({{ dsps }})</span>
              </router-link>
              <router-link :to="{ path: '/challenges', query: { page: 1, tab: 'complete', country: countryFilter, genre: genre } }" class="nav-link" :class="{ active: tab === 'complete' }">
                {{ $t('completed') }}
                <span class="count ml-1" v-if="complete">({{ complete }})</span>
              </router-link>
            </div>
          </div>

          <div v-if="!loading" class="mt-3">
            <div v-if="user.impersonate" class="mb-3">
              <button type="button" class="btn btn-gradient btn-block" @click="claimAll()">
                Claim All (Admins)
              </button>
            </div>
            <div v-for="item in filteredChallenges" v-bind:key="item._id" :class="{ 'magictime holeOut': item.claimed }" v-show="(!item.hide && item.status !== 3) || tab === 'complete'">
              <div class="card gamification-container position-relative box make-it-slow bg-dark text-white">
                <div class="card-body">
                  <div class="badge badge-success pro-badge" v-if="item.pro">PRO</div>
                  <div class="d-flex justify-content-between">
                    <div>
                      <h5>
                        <i @click="showDescription(item)" v-if="item.gamification &&item.gamification.description && $te(item.gamification.description)" class="fa fa-question-circle mr-1 text-info description-icon"></i>
                        <b>{{ $t(item.title) }}</b>
                      </h5>
                      <p class="text-muted">{{ $t('points') }}: {{item.score }}</p>
                    </div>
                    <span class="text-white small">{{ item.count > item.min ? numberWithCommas(item.min) :numberWithCommas( parseFloat(item.count).toFixed(0)) }}/{{ numberWithCommas(item.min) }}</span>
                  </div>
                  <div class="progress progress-sm progress-primary">
                    <div class="progress-bar" :style="'width:' + (((item.count/item.min) * 100) > 100 ? 100 : parseFloat((item.count/item.min) * 100).toFixed(0)) + '%'" role="progressbar" :aria-valuenow="((item.count/item.min) * 100) > 100 ? 100 : parseFloat((item.count/item.min) * 100).toFixed(0)" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div class="mt-3 text-right text-white">
                    <p v-if="((item.count/item.min) * 100) < 100" class="text-muted mb-0">{{ ((item.count/item.min) * 100) > 100 ? 100 : parseFloat((item.count/item.min) * 100).toFixed(0) }}%</p>
                    <button :disabled="showPointsBox" :class="{ 'magictime puffOut': item.claiming }" @click="claim(item)" v-if="((item.count/item.min) * 100) >= 100 && item.status === 2" type="button" class="btn btn-gradient">{{ $t('claim') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="loading" class="mt-3">
            <div class="pt-5 pb-5 text-center">
              <i class="fas fa-spinner fa-2x fa-spin text-muted"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="points-earned bg-dark2 text-white" :class="{ 'animated bounceIn': this.showPointsBox, 'animated zoomOut': this.hidePointsBox }" v-if="showPointsBox">
      <div>
        <i class="fa fas fa-trophy text-warning animation-delay-200 animated zoomIn"></i>
      </div>
      <div class="mt-3">
        {{ $t('congrats_have_earned') }} <b>{{ claimedScore }}</b> {{ $t('points').toLowerCase() }}!
      </div>
    </div>

    <div ref="modalRankings" class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" style="max-width: 800px !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold">
              Rankings
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              &times;
            </button>
          </div>
          <div class="modal-body modal-rankings-content p-0">
            <div class="p-2">
              <div class="row">
                <div class="col-md-6">
                  <select class="form-control mb-1" v-model="genre" @change="showRankings()">
                    <option value="">{{ $t('all_genres') }}</option>
                    <option v-for="(genre, index) in genres" :value="genre" v-bind:key="`genre2_${index}`">{{ genre }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <select class="form-control mb-1" v-model="countryFilter" @change="showRankings()">
                    <option value="">{{ $t('all_countries') }}</option>
                    <option v-for="(_country, index) in countries" :value="_country" v-bind:key="`country2_${index}`">{{ _country }}</option>
                  </select>
                </div>
              </div>
            </div>
            <p class="text-center p-3 mt-1" v-if="loadingRankings">
              <i class="fa fa-spinner fa-spin"></i>
            </p>
            <div class="modal-scroll">
              <div class="table-responsive" v-if="!loadingRankings">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Artist</th>
                      <th>Country</th>
                      <th>Main Genre</th>
                      <th>Ranking</th>
                      <th>Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in artistsList" v-bind:key="item._id" :class="{ 'row-user': item.user && item.user._id === user._id }">
                      <td>{{ ((page - 1) * 100) + (index + 1) }}</td>
                      <td>
                        <a :href="'https://indiefy.me/' + item.key" target="_blank">
                          {{ item.name }}
                        </a>
                      </td>
                      <td>
                        <!-- <img width="16" :src="'/static/img/countries/' + (item.user ? item.user.country : 'MX') + '.png'" :alt="item.legal_country" onerror="this.src = '/static/img/countries/default.png'" class="mr-1"> {{ item.legal_country }} -->
                        {{ item.legal_country }}
                      </td>
                      <td>{{ item.main_genre }}</td>
                      <td>{{ item.ranking ? item.ranking.rank : 'Unranked' }}</td>
                      <td>{{ item.ranking ? numberWithCommas(item.ranking.score) : 0 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="text-right p-3" v-if="!loadingRankings">
              <span class="email-pagination-indicator" v-if="total && limit">Page {{ page }} of {{ Math.ceil(total/limit) }}</span>
              <span class="email-pagination-indicator" v-if="loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
              <div class="btn-group ml-3 paginator">
                <button type="button" @click="page = page - 1; showRankings()" class="btn btn-default btn-border" :disabled="page <= 1">
                  <i class="fa fa-angle-left"></i>
                </button>
                <button type="button" @click="page = page + 1; showRankings()" class="btn btn-default btn-border" :disabled="(page >= Math.ceil(total/limit))">
                  <i class="fa fa-angle-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from './utils/Select2'
import _ from 'underscore'
import ArtistGamification from '../services/artistGamification'
import Artists from '../services/artists'
import moment from 'moment'
import genres from '../data/genres'
import countries from '../data/countries'
import Filters from '../components/utils/filters'

export default {
  name: 'Challenges',
  data () {
    return {
      claimedScore: 0,
      top10: [],
      loadingNearbyRankings: true,
      loadingRankings: false,
      showPointsBox: false,
      defaultCachedArtist: '',
      tab: 'all',
      loading: true,
      challenges: [],
      allChallenges: 0,
      streams: 0,
      country: 0,
      releases: 0,
      dsps: 0,
      pros: 0,
      complete: 0,
      user: {},
      artists: [],
      artistsShortList: [],
      artistsList: [],
      currentArtist: {},
      countries: _.map(countries, (country) => { return country.name }),
      achievments: 0,
      medals: 0,
      artistScore: 0,
      genre: '',
      countryFilter: '',
      genres: _.map(genres, (genre, key) => { return key }),
      artistNextScore: 0,
      ranksScore: {
        'Unranked': {nextRank: 'Bronze', nextScore: 100},
        'Bronze': {nextRank: 'Silver', nextScore: 1000},
        'Silver': {nextRank: 'Gold', nextScore: 2500},
        'Gold': {nextRank: 'Platinum', nextScore: 4000},
        'Platinum': {nextRank: 'Diamond', nextScore: 6000},
        'Diamond': {nextRank: 'Star', nextScore: 10000},
        'Star': {nextRank: 'Superstar', nextScore: 25000},
        'Superstar': {nextRank: 'Legend', nextScore: 50000},
        'Legend': {nextRank: 'Rockstar', nextScore: 100000}
      },
      total: 0,
      limit: 100,
      page: 1
    }
  },
  computed: {
    filteredChallenges: function () {
      let filtered = this.challenges

      if (this.tab === 'all') {
        return filtered
      } else if (this.tab === 'streams') {
        return _.filter(filtered, item => item.type === 'streams')
      } else if (this.tab === 'country') {
        return _.filter(filtered, item => item.type === 'country')
      } else if (this.tab === 'releases') {
        return _.filter(filtered, item => item.type === 'Releases')
      } else if (this.tab === 'dsps') {
        return _.filter(filtered, item => item.type === 'DSPs')
      } else if (this.tab === 'pros') {
        return _.filter(filtered, item => item.pro === 1)
      } else if (this.tab === 'complete') {
        return _.filter(filtered, item => item.status === 3)
      }
    }
  },
  methods: {
    claimAll: function () {
      _.each(this.filteredChallenges, item => {
        if (((item.count / item.min) * 100) >= 100 && item.status === 2) {
          this.claim(item)
        }
      })
    },
    initParams: function () {
      if (this.$route.query.country) {
        this.countryFilter = this.$route.query.country
      }

      if (this.$route.query.genre) {
        this.genre = this.$route.query.genre
      }

      if (this.$route.query.tab) {
        this.tab = this.$route.query.tab
      }
    },
    getTop10: function () {
      ArtistGamification.artistList({ genre: this.genre, country: this.countryFilter, page: 0, limit: 10 }).then(response => {
        this.top10 = response.data.items
      })
    },
    showProModal: function () {
      window.swal({
        title: this.$t('pro_account_needed'),
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: this.$t('cancel'),
            visible: true,
            className: 'btn btn-default'
          },
          confirm: {
            text: this.$t('upgrade_now'),
            className: 'btn btn-success'
          }
        }
      }).then(result => {
        if (result) {
          this.$router.push('/upgrade?from=challenges_filters')
        }
      })
    },
    changeGenre: function () {
      if (!this.user.subscription) {
        this.genre = ''

        this.showProModal()
        return
      }

      this.$router.push({ path: `/challenges`, query: { page: 1, country: this.countryFilter, genre: this.genre } })
    },
    changeCountry: function () {
      if (!this.user.subscription) {
        this.countryFilter = ''

        this.showProModal()
        return
      }

      this.$router.push({ path: `/challenges`, query: { page: 1, country: this.countryFilter, genre: this.genre } })
    },
    showDescription: function (item) {
      window.swal(this.$t(item.gamification.description || ''), {
        buttons: {
          confirm: {
            className: 'btn btn-primary'
          }
        }
      })
    },
    changeArtist: function (artist) {
      localStorage.setItem('defaultCachedArtist', artist._id)
      this.currentArtist = artist
      this.artistsShortList = []
      this.artistScore = this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].score : 0
      this.artistNextScore = this.ranksScore[this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].rank : 'Unranked'].nextScore
      this.$forceUpdate()
      this.getGamifications()
    },
    showRankings: function () {
      this.artistsList = []
      this.loadingRankings = true

      if (!this.user.subscription) {
        if (this.genre || this.countryFilter) {
          this.genre = ''
          this.countryFilter = ''

          window.$(this.$refs.modalRankings).modal('hide')
          return this.showProModal()
        }
      }

      ArtistGamification.artistList({ genre: this.genre, country: this.countryFilter, page: this.page - 1, limit: this.limit }).then(response => {
        this.total = response.data.total
        this.artistsList = response.data.items
        this.loadingRankings = false
        this.$forceUpdate()
      })

      window.$(this.$refs.modalRankings).modal('show')
    },
    claim: function (item) {
      if (item.pro && !this.user.subscription) {
        return this.$router.push('/upgrade?from=pro_challenge_item')
      }

      item.claiming = true
      this.claimedScore = item.score

      ArtistGamification.getReward({ id: item._id }).then(response => {
        item.claimed = true
        this.hidePointsBox = false

        if (response && response.data) {
          this.currentArtist.ranking = [response.data]
          this.artistScore = this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].score : 0
          this.artistNextScore = this.ranksScore[this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].rank : 'UNRANKED'].nextScore
        }

        // Get challenges from API
        setTimeout(() => {
          this.challenges = _.filter(this.challenges, elem => {
            return elem._id !== item._id
          })

          setTimeout(() => {
            this.showPointsBox = true

            setTimeout(() => {
              this.hidePointsBox = true

              setTimeout(() => {
                this.showPointsBox = false
                this.$forceUpdate()
              }, 300)

              this.$forceUpdate()
            }, 1000)

            this.$forceUpdate()
          }, 10)
        }, 300)

        this.$forceUpdate()
      })

      this.$forceUpdate()
    },
    getGamifications: function () {
      this.loading = true

      if (this.currentArtist._id) {
        let date = localStorage.getItem('updateData')
        ArtistGamification.getAll({ artist: this.currentArtist._id, date: date }).then(response => {
          this.challenges = response.data
          this.loading = false
          this.artistScore = this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].score : 0
          this.artistNextScore = this.ranksScore[this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].rank : 'Unranked'].nextScore

          if (!localStorage.getItem('updateData') || localStorage.getItem('updateData') !== moment().format('YYYY-MM-dd')) {
            localStorage.setItem('updateData', moment().format('YYYY-MM-dd'))
          }

          this.challenges = this.hideChallenges(this.challenges)
          this.challenges = _.sortBy(_.sortBy(_.sortBy(_.sortBy(this.challenges, 'min'), 'data').reverse(), 'status'), 'type').reverse()

          this.allChallenges = _.filter(
            this.challenges,
            item => (!item.hide && (item.status === 1 || item.status === 2))
          ).length
          this.streams = _.filter(
            this.challenges,
            item => (item.type === 'streams' && !item.hide && (item.status === 1 || item.status === 2))
          ).length
          this.country = _.filter(
            this.challenges,
            item => (item.type === 'country' && !item.hide && (item.status === 1 || item.status === 2))
          ).length
          this.releases = _.filter(
            this.challenges,
            item => (item.type === 'Releases' && !item.hide && (item.status === 1 || item.status === 2))
          ).length
          this.dsps = _.filter(
            this.challenges,
            item => (item.type === 'DSPs' && !item.hide && (item.status === 1 || item.status === 2))
          ).length
          this.pros = _.filter(
            this.challenges,
            item => (item.pro === 1 && !item.hide && (item.status === 1 || item.status === 2))
          ).length
          this.complete = _.filter(
            this.challenges,
            item => (item.status === 3)
          ).length
          this.achievments = _.filter(
            this.challenges,
            item => ((item.status === 2 || item.status === 3) && item.rank !== 'medal')
          ).length
          this.medals = _.filter(
            this.challenges,
            item => ((item.status === 2 || item.status === 3) && item.rank === 'medal')
          ).length

          this.challenges = _.sortBy(_.sortBy(_.sortBy(_.sortBy(this.challenges, 'min'), 'data').reverse(), 'type'), 'status').reverse()

          setTimeout(() => {
            this.$forceUpdate()
          }, 500)
        })

        this.getNearbyRankings()
      }
    },
    getNearbyRankings: function () {
      this.loadingNearbyRankings = true

      ArtistGamification.artistShortList(this.currentArtist._id, { country: this.countryFilter, genre: this.genre }).then(response => {
        if (response.data) {
          this.artistsShortList = _.filter(
            response.data,
            item => item
          )

          this.loadingNearbyRankings = false

          setTimeout(() => {
            this.$forceUpdate()
          }, 500)
        }
      })
    },
    hideChallenges: function (dataArray) {
      let min = 1
      let type = ''
      let data = ''
      dataArray = _.sortBy(_.sortBy(_.sortBy(_.sortBy(this.challenges, 'min'), 'data').reverse(), 'status'), 'type').reverse()

      _.map(dataArray, (challenge, idx) => {
        if (challenge.status === 1 && challenge.rank === 'medal') {
          challenge.hide = 1
        }
        if (idx === 0) {
          type = challenge.type
        }
        if (challenge.type === type) {
          if (challenge.data === data) {
            min++
            if (challenge.status === 1 && min > 0) {
              challenge.hide = 1
            }
          } else {
            data = challenge.data
            min = 0
          }
        } else {
          challenge.showType = 1
          type = challenge.type
          min = 0
        }
      })
      // sdataArray = _.sortBy('status').reverse()
      return dataArray
    },
    numberWithCommas: function (x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return x
      }
    }
  },
  created: function () {
    this.user = this.$user
    this.defaultCachedArtist = localStorage.getItem('defaultCachedArtist')
    this.artistsShortList = []

    Artists.getAll().then(response => {
      this.artists = _.map(response.data, item => {
        return {
          id: item._id,
          _id: item._id,
          text: item.name,
          name: item.name,
          spotify_id: item.spotify_id,
          cover_image: item.cover_image,
          cover_image_small: item.cover_image_small,
          ranking: item.ranking
        }
      })

      if (!this.artists.length) {
        return this.$router.push('/artists')
      }

      if (this.defaultCachedArtist && _.find(this.artists, item => item._id === this.defaultCachedArtist)) {
        this.currentArtist = _.find(this.artists, item => item._id === this.defaultCachedArtist)
      } else {
        this.currentArtist = this.artists[0]
      }

      setTimeout(() => {
        this.artistScore = this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].score : 0
        this.artistNextScore = this.ranksScore[this.currentArtist.ranking && this.currentArtist.ranking.length ? this.currentArtist.ranking[0].rank : 'Unranked'].nextScore
        this.$forceUpdate()
      }, 500)

      this.initParams()
      this.getGamifications()
      this.getTop10()
    })
  },
  mounted: async function () {
    window.$(document).off('mouseenter', '.drop-button')
    window.$(document).on('mouseenter', '.drop-button', function () {
      window.$(this).trigger('click')
    })

    window.$(document).off('mouseleave', '.gamification-container ')
    window.$(document).on('mouseleave', '.gamification-container ', function () {
      if (window.$(this).find('.dropdown-menu').hasClass('show')) {
        window.$(this).find('.drop-button').trigger('click')
      }
    })
  },
  components: {
    Select2
  },
  filters: {
    truncate: Filters.truncate
  },
  watch: {
    $route (to, from) {
      this.initParams()
      this.getGamifications()
    }
  }
}
</script>

<style lang="scss" scoped>
  .row-user {
    background: #e9ffea;
    font-weight: bold;
  }

  .bg-indiefy {
    background: rgb(114,137,218);
    background: linear-gradient(270deg, rgba(114,137,218,1) 10%, rgba(39,39,93,1) 50%, rgba(2,0,36,1) 90%);
  }
  .box {
    box-shadow: 0 1px 2px rgba(0,0,0,0.15);
    transition: all 0.3s ease-in-out;
  }
  .box::after {
    content: '';
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    opacity: 0;
    border-radius: 5px;
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
    transition: opacity 0.3s ease-in-out;
  }
  .make-it-slow {
    box-shadow: 0 1px 2px rgba(0,0,0,0.15);
    transition: box-shadow 0.3s ease-in-out;
  }

  .make-it-slow .card-body {
    border-left: 4px solid #1e1b34;
    border-radius: 4px;
  }

  .make-it-slow .card-body:hover {
    transition: all 0.2s ease-in;
    border-left: 4px solid #007bff;
  }
  .info-post {
    width: 81%;
    display: block;
  }

  .header-avatar {
    border-radius: 6px 6px 0 0 !important;
    background-image: url('/static/img/gamification/banner-bg.jpg');
    background-size: cover;
    background-repeat: no-repeat;
  }

  .points-earned {
    text-align: center;
    position: fixed;
    border-radius: 3px;
    top: 25%;
    left: 50%;
    width: 450px;
    margin-left: -225px;
    z-index: 1000;
    padding: 32px;
    border-radius: 6px;
    font-size: 18px;

    i {
      font-size: 34px;
    }
  }

@media only screen and (max-width: 768px) {
  .points-earned {
    width: 350px;
    margin-left: -175px;
    padding: 25px;
  }
}

.rank-progress {
  height: 10px;
}

.rankings .username,
.blue-text {
  color: #13BBCD !important;
}

.modal-rankings-content .modal-scroll {
  max-height: 400px;
  overflow-y: auto;
}

.pro-badge {
  position: absolute;
  right: -6px;
  top: -10px;
}

.description-icon {
  cursor: pointer;
}

.genres-select {
  background: #321c72;
  color: white;
  border: none;
}

.marquee-container {
  position: relative;
}

.marquee-container marquee {
  padding-left: 100px;
}

.marquee-container .marquee-title {
  padding: 8px 9px;
  color: white;
  font-weight: bold;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 30%;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/Challenges.vue